<div class="form-row">
  <div class="form-group col-md-6">
    <label>Name</label>
    <input type="text" name='name' [(ngModel)]='this.productClass.name' [class.is-invalid]='!this.productClass.name' class="form-control">
  </div>
  <div class="form-group col-md-6">
    <label>Code</label>
    <input type="text" name='code' [(ngModel)]='this.productClass.code' [class.is-invalid]='!this.productClass.code' class="form-control">
  </div>
  <div class="form-group col-md-12">
    <label>Description</label>
    <textarea name='description' [(ngModel)]="this.productClass.description" class="form-control"></textarea>
  </div>
</div>
